import { environment } from 'src/environments/environment';

export abstract class CostFunctionRow {
    weight: string = environment.costFunction.weight.default;
}
